// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"428":"8836cce1","440":"02341fba","791":"2e5c0b61"}[chunkId] + ".js";
};